<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div class="card-header border-0">
        <h5 class="card-title font-bold">مرتب‌سازی دسته‌بندی‌ها</h5>
        <div style="flex: 1"></div>
        <b-button
          v-if="change"
          @click="sortCategory"
          :disabled="disabled || !hasPermission('modify_category')"
          variant="info"
        >
          اعمال تغییرات
        </b-button>
      </div>

      <div class="card-body">
        <div class="alert alert-info">
          دسته‌بندی‌ها را با درگ و دراپ جابه‌جا کنید و در پایان روی «اعمال تغییرات» بزنید.
        </div>

        <template v-if="items != null">
          <VueNestable v-model="items" rtl :maxDepth="1" @change="onChange">
            <VueNestableHandle slot-scope="{ item }" :item="item">
              <span style="user-select: none">
                <i class="fa fa-arrows-v" style="font-size: 11px"></i>
                {{ item.id + " - " + item.title }}
              </span>
            </VueNestableHandle>
          </VueNestable>
        </template>

        <Loading v-if="items == null" />
        <div v-if="items && !items.length" class="alert alert-danger">موردی یافت نشد</div>
      </div>
    </div>
  </main>
</template>

<script>
import Loading from "@@/core/components/shared/Loading/Loading";
import "@@/assets/admin/vue-nestable.css";
import mixins from "@@/core/mixins/mixins";
import { BButton } from "bootstrap-vue";
import { VueNestable, VueNestableHandle } from "vue-nestable";

export default {
  name: "CategorySortOrder",
  components: {
    Loading,
    BButton,
    VueNestable,
    VueNestableHandle,
  },
  mixins: [mixins],
  data() {
    return {
      url: "admin/categories",
      items: null,
      disabled: false,
      change: false,
    };
  },
  created() {
    this.loadItems();
  },
  methods: {
    async loadItems() {
      try {
        const response = await this.$axios.get(this.url + "?all=1&special=1");
        this.items = response.data.data.categories.map((c) => ({
          id: c.id,
          title: c.title,
        }));
      } catch (error) {
        this.$root.notify(error);
      }
    },
    onChange() {
      this.change = true;
    },
    async sortCategory() {
      const categoryIds = this.items.map((i) => i.id);
      try {
        this.disabled = true;
        const response = await this.$axios.post("admin/category/sort-order", {
          categoryIds: categoryIds,
        });
        this.$root.notify(response.data.message, "success");
        this.change = false;
      } catch (error) {
        this.$root.notify(error);
      } finally {
        this.disabled = false;
      }
    },
    sanitizeCategory(c) {
      return {
        id: c.id,
        children: (c.children || []).map((cc) => this.sanitizeCategory(cc)),
      };
    },
  },
};
</script>

<style src="@@/core/pages/category/Category/CategoryStylePublic.css"></style>
